import { Periods } from '@shared/utils/History/TFInfo';
import { HistoryMergerBySeconds } from './HistoryMergerBySeconds';
import { HistoryMergerDay } from './HistoryMergerDay';
import { HistoryMergerExtraday } from './HistoryMergerExtraday';
import { HistoryMergerIntradayByDayStart } from './HistoryMergerIntradayByDayStart';
import { HistoryMergerIntrdayBySession } from './HistoryMergerIntrdayBySession';
import { HistoryMergerMonth } from './HistoryMergerMonth';
import { HistoryMergerWeek } from './HistoryMergerWeek';
import { HistoryMergerYear } from './HistoryMergerYear';
class _HistoryMergerCreator {
    GetHistoryMerger(inputParams) {
        const period = inputParams.NewPeriod;
        if (period % Periods.DAY === 0 || period % Periods.YEAR === 0) {
            return this.GetHistoryMergerByDay(inputParams);
        }
        else if (period % Periods.SECOND === 0) {
            return this.GetHistoryMergerBySecond(inputParams);
        }
        else {
            return this.GetHistoryMergerByMin(inputParams);
        }
    }
    GetHistoryMergerByDay(inputParams) {
        const period = inputParams.NewPeriod;
        if (period % Periods.YEAR === 0) {
            return new HistoryMergerYear(inputParams);
        }
        else if (period % Periods.MONTH === 0) {
            return new HistoryMergerMonth(inputParams);
        }
        else if (period % Periods.WEEK === 0) {
            return new HistoryMergerWeek(inputParams);
        }
        else {
            return new HistoryMergerDay(inputParams);
        }
    }
    GetHistoryMergerByMin(inputParams) {
        const instrument = inputParams.Instrument;
        const period = inputParams.NewPeriod;
        if (period > Periods.DAY) {
            return new HistoryMergerExtraday(inputParams);
        }
        const aggregateIntradayBySession = instrument === null || instrument === void 0 ? void 0 : instrument.AllowFilterBarsBySession(period);
        if (aggregateIntradayBySession) {
            return new HistoryMergerIntrdayBySession(inputParams);
        }
        return new HistoryMergerIntradayByDayStart(inputParams);
    }
    GetHistoryMergerBySecond(inputParams) {
        return new HistoryMergerBySeconds(inputParams);
    }
}
export const HistoryMergerCreator = new _HistoryMergerCreator();
